<div
  *ngIf="templatePreviewType$ | async as templateType"
  class="template-preview"
  [class.full-screen]="fullMediaConfig.fullscreen">
  <ng-container [ngSwitch]="templateType">
    <lib-lottie-template
      *ngSwitchCase="CFSTemplateType.Lottie"
      #currentTemplate
      class="template-preview__item"
      [isPrintView]="isPrintView"
      [animationType]="animationType"
      [screenSize]="templateScreenSize$ | async"
      [options]="previewOptions$ | async"
      (ready)="onTemplateReady()"
      (error)="onTemplateError($event)"
      (printReady)="onPrintReady()">
    </lib-lottie-template>

    <lib-html-template
      *ngSwitchCase="CFSTemplateType.Html"
      #currentTemplate
      class="template-preview__item"
      [animationType]="animationType"
      [isPrintView]="isPrintView"
      [screenSize]="templateScreenSize$ | async"
      [configurationOptions]="configurationOptions$ | async"
      [parameters]="parameters$ | async"
      [responsive]="responsive"
      [isLowResolutionScreen]="isLowResolutionScreen"
      (error)="onTemplateError($event)"
      (ready)="onTemplateReady(); onPrintReady();">
    </lib-html-template>

    <lib-video-template
      *ngSwitchCase="CFSTemplateType.Video"
      #currentTemplate
      class="template-preview__item"
      [templateName]="templateName"
      [animationType]="animationType"
      [mediaConfig]="fullMediaConfig"
      [templateProperties]="templateProperties"
      [displayTime]="displayTime"
      (ready)="onTemplateReady()"
      (error)="onTemplateError($event)">
    </lib-video-template>

    <lib-image-template
      *ngSwitchCase="CFSTemplateType.Image"
      #currentTemplate
      class="template-preview__item"
      [mediaConfig]="fullMediaConfig"
      [isPrintView]="isPrintView"
      [animationType]="animationType"
      [templateProperties]="templateProperties"
      (ready)="onTemplateReady()"
      (error)="onTemplateError($event)">
    </lib-image-template>

    <lib-cmc-qr-code-template
      *ngSwitchCase="CFSTemplateType.CmcQrCode"
      #currentTemplate
      class="template-preview__item"
      [animationType]="animationType"
      [screenSize]="templateScreenSize$ | async"
      [parameters]="parameters$ | async"
      [responsive]="responsive"
      [isLowResolutionScreen]="isLowResolutionScreen"
      (ready)="onTemplateReady()"
      (error)="onTemplateError($event)">
    </lib-cmc-qr-code-template>

    <lib-generated-html-template
      *ngSwitchDefault
      #currentTemplate
      class="template-preview__item"
      [isPrintView]="isPrintView"
      [animationType]="animationType"
      [generatedBody]="generatedBody"
      (ready)="onTemplateReady()"
      (error)="onTemplateError($event)">
    </lib-generated-html-template>
  </ng-container>
</div>
